(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball-eurojackpot.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball-eurojackpot.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
class BallEurojackpot extends svs.tur.ball.Default {
  constructor(options) {
    options.productId = 'Eurojackpot';
    super(options);
    this.log = new svs.core.log.Logger('ball.eurojackpot');
  }
  classNames() {
    const classNames = ['ball-eurojackpot'];
    if (this.extraNumber) {
      classNames.push('ball-extra-number');
    }
    return classNames;
  }
}
svs.tur.ball.Eurojackpot = BallEurojackpot;

 })(window);